// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const ConditionalColoringDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-conditionalcoloringdialogcontainer" */ "./ConditionalColoringDialogContainer")).then((bundle)=>{
        return {
            default: bundle.ConditionalColoringDialogContainer
        };
    });
export const LazyConditionalColoringDialogContainer = /*#__PURE__*/ lazy(ConditionalColoringDialogContainerLazyLoader);
